import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'

const { Option } = Select 
const axios = require("axios");

/**
 * @const SelectProveedor
 * @description Select para los proveedores registrados en el sistema
 */
const SelectProveedor = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione el proveedor", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {} 
    } = props

    const [ proveedores, setProveedores ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getProveedores
     * @description Obitiene los proveedores
     */
    const getProveedores = ({page, limit, search} = proveedores) => {

        axios.get('/proveedores', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
            headers: { Authorization: sessionStorage.getItem('token') }
        }).then(({ data }) => {
            setProveedores(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener los proveedores')
        })
    }

    //componentDidMount
    useEffect(() => {
        getProveedores()
    }, [])

    useEffect(() => {
        onChange(value?.value ?? value)
    }, [value])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            onSearch={(search)=> getProveedores({search})}
            onSelect={(proveedor)=> {
                onChange(proveedor.value)
                onSelect(proveedor.value)
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                proveedores?.data?.map(({ _id, alias }) => <Option value={_id}>{alias ?? ""} {}</Option>)
            }
        </Select>
    );
}



export default SelectProveedor;